import type { NAuth } from '@app/types/Auth';
import type { NUtils } from '@app/types/Utils';

export const addUserPrintAsParams: NUtils.AddUserPrintAsParams = (
  userIdOrUserPrint,
  database,
  activeBranchId
) => {
  const isUserPrintAsObject = userIdOrUserPrint?.hasOwnProperty('userId');

  if (isUserPrintAsObject) {
    const { userId, database, activeBranchId } =
      userIdOrUserPrint as NAuth.UserPrint;

    return `?UserId=${userId}&Database=${database}&ActiveBranchId=${activeBranchId}`;
  } else {
    const userId = userIdOrUserPrint as NAuth.UserPrint['userId'];

    return `?UserId=${userId}&Database=${database}&ActiveBranchId=${activeBranchId}`;
  }
};
